import { render, staticRenderFns } from "./CategoryAccounts.vue?vue&type=template&id=22facd22&scoped=true&"
import script from "./CategoryAccounts.vue?vue&type=script&lang=js&"
export * from "./CategoryAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22facd22",
  null
  
)

export default component.exports